module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C241"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("ANNOTATED TABLE OF CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "C131"
  }, [_vm._v("KATE BERNHEIMER")])]), _c('p', {
    staticClass: "C132"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Editor_s_Note#page_13"
    }
  }, [_vm._v("Editor’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("“All great novels are great fairy tales,” wrote Vladimir Nabokov many years ago, and FAIRY TALE REVIEW continues to believe that all great literary works owe everything to fairy tales.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("IVY ALVAREZ")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_IVY_ALVAREZAuto_biography__or_so#page_15"
    }
  }, [_vm._v("Auto/biography, or so I was tolde")])])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("she pickes mye foote up by the heele")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("dragges hir fingre padde")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("along myn arche")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("& seith unto me")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("thow hath a noblewoman’s foote")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("(tho I was but a chylde)")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("PHILIP BEIDLER")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "C111"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/09_PHILIP_BEIDLER_America_s_Fairy_T#page_19"
    }
  }, [_vm._v("America’s Fairy Tale")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("A character tries to escape civilization by journeying into nature, where he falls asleep in the past and wakes up in the future. For that character, history becomes an unbounded present where all things are possible.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("MARGO BERDESHEVSKY")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/10_MARGO_BERDESHEVSKY_Window#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Window")])])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("She hated Saint Valentine’s day. A woman in a garter belt.")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("And a moth who feeds on spice.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("ANN FISHER-WIRTH")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/11_ANN_FISHER_WIRTHVariations_on_th#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Variations on the Robber Bridegroom")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("What use, mother, the sunlight and new milk, the lambs with bobbing tails, even these violets, blue as sleep, without his body?")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("TONY FRIEDHOFF")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/12_TONY_FRIEDHOFF_Three_Poems#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Poems")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("A man becomes tied to the ground. Other than the growing of grass, there’s nothing much, but I never realized how rhythmically this can happen, and all the wild animals teaching him to dance in the movements of one who is tied to the ground, in the movements of one who is being eaten. Who is being kind here?")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("ARIELLE GREENBERG")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_ARIELLE_GREENBERGFour_Poems#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Poems")])])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("This is the folk tale version in which you ride out to sea on the back of a turtle and it feels like moss on the backs of your teeth. You hang a clock in the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("You are the folk-tale virgin.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("EVAN HARRIS")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_EVAN_HARRISThe_Future_of_Despair#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Future of Despair")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("The future is a low stone wall obscured by mist. It runs the far end of an untended meadow that grows in weak scrubby patches, pale cover, and high tannish grass. Above the wall, mist gathers white gray, softly opaque. The stones of the wall mass, edges meeting and missing according to shape, order of placement, angle of balance. Gaps form buffers between unmatched solidities.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("MC HYLAND")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_MC_HYLAND__Bird__how_beautifully#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Bird, how beautifully you sing!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("O makes a hole in the firmament & we treble through.")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("Under cover of high notes, the skin slips under covers. The wolf hiding.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("LESLEY JENIKE")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "C111"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('em')]), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_LESLEY_JENIKEThree_Enter_the_Dar#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Enter the Dark Wood")])])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("It’s the one about the bears and their blonde:")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("In their many beds I left many cells")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("called my multiple personalities down")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("their faces to the sky")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("a slide show of cheap reference, chanteuses")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("orphaned by a wave of bear.")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("Life should have piano accompaniment—")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("KAMILA LIS")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_KAMILA_LISTwo_Poems#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Poems")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("That first time I saw myself miraculous, we baked swan-fat into bread when Satan whispered, “I can’t think of anything that can make me smile like you can and although you are perfect you have come too early and are here where something laughing will be shaped deliberately, ball of a palm pressed into moist clay.”")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("ASHLEY McWATERS")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_ASHLEY_McWATERS_Seven_Poems#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven Poems")])])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("I weave a train its nameless tracks")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("late and claimless, scumbled thimble")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_vm._v("for blessing. No owl or bright bride")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("I weave myself to lace, to let in air.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("BARBARA JANE REYES")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "C111"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('em')]), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_BARBARA_JANE_REYESThe_Duyong_Ser#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Duyong Series")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("At midnight, the old men gather with oil lanterns aboard their fishing boats. With rosaries in hand, they stab the water with machetes. Their sons say, “Do not be foolish. There are no more mermaids here. It is the crocodiles who are stealing our young ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("TIMOTHY SCHAFFERT")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/20_TIMOTHY_SCHAFFERTThe_Young_Widow#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Young Widow of Barcelona")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_vm._v("Suicide note?")]), _vm._v(" the minister asked, and Eve thought of music, remembering, listening for wilting notes of suicide in snippets of her late husband’s voice.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("KURT SCHWITTERS")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("Translated by Jack Zipes")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/21_KURT_SCHWITTERS#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Swineherd and the Great, Illustrious Writer")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("A swineherd was tending his pigs and playing his flute at the same time: “Tweet, tweet, tweet, tweet, tweet, tweet, tweet.”")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("KELLIE WELLS")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/22_KELLIE_WELLSRabbit_Catcher_of_Ki#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rabbit Catcher of Kingdom Come")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("One sudden spring, when trees and flowers, bamboozled by warmth, began budding in January, the prematurely honied air flatly refusing to chill again until late December, the town of Kingdom Come, Kansas, was beset by a plague of black-tailed jack rabbits that were not only many but jumbo, bigger than great danes they were, gar"), _c('em', [_vm._v("gan")]), _vm._v("tuan rabbits, suspiciously well-fed, slavering over the zoysia, plump middles heaving, back feet long and brawny as a sailor’s forearm and ears you could fan a fainting princess with.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("DARA WIER")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "C111"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('em')]), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/23_DARA_WIERThe_Wizard#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wizard")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("At dawn and at dusk I leave the house to graze in the meadow beyond the river. There’s a trail I’ve covered with straw to follow and a convenient string of boulders I can use to make my way across the water. I sleep all through the day and work through the night.")]), _vm._v(" "), _c('p', {
    staticClass: "C131"
  }, [_vm._v("IMANTS ZIEDONIS")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("Translated by Bitite Vinklers")]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/24_IMANTS_ZIEDONIS#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Tales")])])]), _vm._v(" "), _c('p', {
    staticClass: "C111"
  }, [_vm._v("The sun, like a bright golden egg, gleamed in the sky. There was life within the sun: baby chicks, all light yellow, descended to earth along the sun’s rays. Later on the chicks will strut about in other colors, but they all arrive a sunny yellow.")]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Contributor_Notes#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributor Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Acknowledgments#page_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C132"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Announcements#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Announcements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4306ce2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_ANNOTATED_TABLE_OF_CONTENTS.vue
// module id = 69
// module chunks = 0